<template src="./index.html"></template>
<script>
import Navbar from '@/components/Navbar';
import CustomButton from '@/components/CustomButton';
import { RotateSquare2 } from '@/components/vue-loading-spinner/src';

export default {
  name: 'Landing',
  components: { Navbar, CustomButton, RotateSquare2 },
  data() {
    return {
      isLoading: true,
      email: '',
      activeFeature: 'team'
    };
  },
  created() {
    this.isLoading = true;
  },
  mounted() {
    clickmagick_cmc.log('a');
    this.updateLoading();
  },
  methods: {
    updateLoading() {
      setTimeout(() => {
        console.log('loaded');
        this.isLoading = false;
      }, 1000);
    },
    async goto(page) {
      await this.$router.push(page);
    },
    test() {
      console.log("s")
    },
    analytics() {  gtag_report_conversion()    }
  }
};
</script>

<style scoped>
.loading {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
